














import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import StaffProductReviewCard from '~/components/pages/Staff/StaffProductReviewCard.vue';
import AppSeeMoreButton from '~/components/partials/App/AppSeeMoreButton.vue';
import { StaffReview } from '~/types/modules/staff';

export default defineComponent({
  components: {
    AppSeeMoreButton,
    StaffProductReviewCard,
  },
  props: {
    reviews: {
      type: Array as PropType<StaffReview[]>,
      default: () => [],
    },
    total: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isLoadMoreButtonVisible = computed(() => props.total !== props.reviews.length);

    const clickSeeMore = () => {
      emit('clickSeeMore');
    };

    return {
      isLoadMoreButtonVisible,
      clickSeeMore,
    };
  },
});
